import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import lodash from "lodash";

class ExcelServices {
  static generateData({ headers, data, fn }) {
    const finalData = [];
    data.forEach((item) => {
      const obj = {};
      headers.forEach(({ field, headerName }) => {
        const value =
          ((typeof fn === "function" && fn(field, item)) ||
            lodash.get(item, field)) ??
          "-";
        obj[headerName] = String(value);
      });
      finalData.push(obj as never);
    });
    return finalData;
  }

  static generateColumnWidth(finalData) {
    const headLengthsList = {};
    finalData.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (headLengthsList[key]) {
          headLengthsList[key].push(item[key].toString().length);
        } else {
          headLengthsList[key] = [key.length, item[key].toString().length];
        }
      });
    });

    return Object.keys(headLengthsList).map((key) => {
      const max = Math.max(...headLengthsList[key]);
      return { wch: max + 3 };
    });
  }

  static generateFile({
    headers,
    data,
    fn,
    fileName = "florapoint-table",
  }: {
    headers: any[];
    data: any[];
    fn?: () => void;
    fileName?: string;
  }) {
    const finalData = this.generateData({ headers, data, fn });
    const worksheet = XLSX.utils.json_to_sheet(finalData);
    worksheet["!cols"] = this.generateColumnWidth(finalData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Страница 1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    FileSaver.saveAs(blob, `${fileName}.xlsx`);
  }
}

export default ExcelServices;
